import { render, staticRenderFns } from "./InvestmentsKoop.vue?vue&type=template&id=46e3c14e&scoped=true"
import script from "./InvestmentsKoop.vue?vue&type=script&lang=js"
export * from "./InvestmentsKoop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e3c14e",
  null
  
)

export default component.exports